import { SettingListType } from 'src/types/types'
import SettingTemplate from 'src/components/atomic/template/Service/Setting'
import { useTranslation } from 'react-i18next'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { commonUtils } from 'src/utils/common.utils'

import SessionStorageUtils from 'src/utils/SessionStorage.utils'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { SocketSender } from 'src/api/socket'

export type SettingDataPropsType = {
  SettingList: SettingListType[]
}

const SettingPage = () => {
  const { Connection } = useAppSelector((state: RootState) => state.connection)
  const { deleteStorageData } = SessionStorageUtils()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const SettingList: SettingListType[] = [
    {
      idx: 0,
      text: t('COMMON.UNLOCK_DEVICE', { defaultValue: 'Unlock Device' }),
      svg: 'setting_unlock',
      className: 'setting_unlock_device',
      onClickFunc: () => {
        if (Connection) {
          dispatch(setModalItems({ type: 'unLockDevice' }))
          return
        } else {
          dispatch(
            setModalItems({
              type: 'alert',
              text: t('MODAL.UNLOCK_DEVICE.OFFLINE', {
                defaultValue: 'Unable to unlock device because your phone is offline.',
              }) as string,
            }),
          )
          return
        }
      },
    },
    {
      idx: 1,
      text: t('SETTING.MENU.FAQ', { defaultValue: 'FAQ' }),
      svg: 'setting_faq',
      className: 'setting_faq',
      onClickFunc: () => commonUtils.OpenExternalPage('https://www.mfinder.ai/help/faq'),
    },
    {
      idx: 2,
      text: t('SETTING.MENU.ANNOUNCEMENTS', { defaultValue: 'Announcements' }),
      svg: 'setting_Announcements',
      className: 'setting_announcements',
      onClickFunc: () => commonUtils.OpenExternalPage('https://www.mfinder.ai/help/news'),
    },
    {
      idx: 3,
      text: t('SETTING.MENU.SIGN_OUT', { defaultValue: 'Sign Out' }),
      svg: 'setting_signout',
      className: 'setting_sign_out',
      onClickFunc: () =>
        dispatch(
          setModalItems({
            type: 'confirm',
            text: `${t('MODAL.SIGN_OUT.DESCRIPTION', {
              defaultValue: 'Are you sure you want to sign out?',
            })}`,
            confirmFunc: () => {
              dispatch(SocketSender(Cmdtypes.LOGOUT))
              deleteStorageData()
            },
            className: 'setting_sign_out',
          }),
        ),
    },
  ]
  const data: SettingDataPropsType = {
    SettingList,
  }

  return <SettingTemplate data={data} />
}
export default SettingPage
